import PostImage from "../assets/formats/post-image.png";
import StoryImage from "../assets/formats/story-image.png";
import Encarte from "../assets/formats/encarte.png";
import CartazRetrato from "../assets/formats/cartaz-retrato.png";
import CartazPaisagem from "../assets/formats/cartaz-paisagem.png";
import TV from "../assets/formats/tv.png";
import Etiqueta from "../assets/formats/etiqueta.png";

import { StatusCampaignAds } from "../types/campaigns"; 
import { AlertColor } from "@mui/lab/Alert";

export const LINKDOWNLOAD_IMPORT_CONTACTS= 'https://log-crm.s3.amazonaws.com/arquivos/modelo_importacao_contatos/MODELO_IMPORTA%C3%87%C3%82O_CONTATOS.xlsx'

export const STATIC_FORMATS = [
  {
    title: "Post",
    subtitle: "Formato quadrado ideal para Facebook e Instagram",
    image: PostImage,
    isVideo: false,
  },
  {
    title: "Post",
    subtitle: "Vídeos em formato de post para redes sociais (quadrado)",
    image: PostImage,
    isVideo: true,
  },
  {
    title: "Story",
    subtitle: "Formato para história do Instagram (não é possível distribuir)",
    image: StoryImage,
    isVideo: false,
  },
  {
    title: "Story",
    subtitle: "Formato para história do Instagram (não é possível distribuir)",
    image: StoryImage,
    isVideo: true,
  },
  {
    title: "Encarte",
    subtitle: "Ideal para criar artes com até 30 produtos",
    image: Encarte,
    isVideo: false,
  },
  {
    title: "Cartaz retrato",
    subtitle:
      "Encarte em pé. Funciona para todos os tamanhos: A5, A4, A3, A2, etc",
    image: CartazRetrato,
    isVideo: false,
  },
  {
    title: "Cartaz paisagem",
    subtitle:
      "Encarte deitado. Funciona para todos os tamanhos: A5, A4, A3, A2, etc",
    image: CartazPaisagem,
    isVideo: false,
  },
  {
    title: "TV (indoor)",
    subtitle: "Formato ideal para colocar na televisão",
    image: TV,
    isVideo: false,
  },
  {
    title: "Etiqueta",
    subtitle: "Etiquetas em A4 para impressão",
    image: Etiqueta,
    isVideo: false,
  },
];

export const STATUS_CAMPAIGN_ADS: StatusCampaignAds = {
  SCHEDULED: 'a campanha está programada.',
  ACTIVE: 'a campanha está ativa e rodando no momento.',
  PAUSED: 'Pausada, Reative a campanha para voltar a processar.',
  DELETED: 'a campanha foi deletada.',
  PENDING_REVIEW: 'a campanha está em análise pelo Facebook.',//'revisão pendente pelo Facebook.'
  DISAPPROVED: 'reprovada pelo Facebook.',
  PREAPPROVED: 'pré-aprovada pelo Facebook.',
  PENDING_BILLING_INFO: 'Erro, por favor contate o suporte.',//pagamento pendente
  CAMPAIGN_PAUSED: 'campanha pausada',
  ARCHIVED: 'campanha arquivada.',
  ADSET_PAUSED: 'conjunto de anúncios pausado.',
  IN_PROCESS: 'a campanha está em análise pelo Facebook.',
  WITH_ISSUES: 'campanha com problemas.',
  FINISH: 'a campanha foi concluída.',
  FINISH_2: 'finalizado'//'finalizada, mas não executada por completo.'
};

export const STATUS_CAMPAIGN_ADS2 = {
  SCHEDULED: 0,
  ACTIVE: 2,
  PAUSED: 3,
  DELETED: 3,
  PENDING_REVIEW: 0,
  DISAPPROVED: 4,
  PREAPPROVED: 0,
  PENDING_BILLING_INFO: 4,
  CAMPAIGN_PAUSED: 3,
  ARCHIVED: 2,
  ADSET_PAUSED: 3,
  IN_PROCESS: 0,
  WITH_ISSUES: 3,
  FINISH: 2,
  FINISH_2: 3,
};

export const severity: Array<AlertColor> = ['info','info','success','warning','error'];

export const STATUS_CAMPAIGN = [
    'Processando',
    'Processando',
    'Processado',
    'Pausado'
];

export const STATUS_CAMPAIGN2 = [
    'a campanha foi agendada.',
    'a campanha está sendo processada.',
    'a campanha foi concluída.',
    'Pausada, Reative a campanha para voltar a processar.',
    'Error, Sua campanha não foi enviada.'
];

/**
 * @description ATTENTION, do not put release environment in this validation. For this,
 * another validation was created - isReleaseEnvironment. If it is of extreme importance to
 * do this, check where this validation is used and make the necessary changes in the code.
 */
export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.includes("market-dev") ||
    // window.location.hostname.includes("tech") ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const isReleaseEnvironment = Boolean(
  window.location.hostname.includes("market-rls")
);

/**
 * The API's env exists only 'dev' and 'prd'
 */
export const ENV = isLocalhost || isReleaseEnvironment ? "dev" : "prd";


export const ONE_MB_SIZE_IN_BYTES = 1000000;